import React, { useEffect, useState } from "react";
import classes from "./ProfilePage.module.css";
import { AnimatePresence, motion } from "framer-motion";
import {
  FaArrowLeft,
  FaClock,
  FaUser,
  FaBolt,
  FaPowerOff,
  FaXmark,
  FaTriangleExclamation,
  FaArrowRightFromBracket,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { userProfileApi, unsubscribe } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import EditProfileModal from "../component/EditProfileModal";
import { removeUser } from "../store/slices/userSlice";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";



const msisdn =  localStorage.getItem("msisdn") || localStorage.getItem("mobile");
console.log(msisdn,"msisdn--");

const getInitials = (name = "") =>
  name?.split(" ")
    .map((item) => item[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const formatTime = (seconds = 0) => {
  const totalSeconds = Number(seconds) || 0;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }

  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }

  return `${secs}s`;
};



const ProfilePage = () => {
  const navigate = useNavigate();
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);

  const [userProfile, setUserProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [unsubscribing, setUnsubscribing] = useState(false);
  const { user } = useSelector(state => state?.persisted?.userSlice);

  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  console.log(user,"------user--")
  
  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await userProfileApi(user?.token);
      console.log(response?.data?.result?.[0],"----------data-------------");
      setUserProfile(response?.data?.result?.[0]);
    } catch (error) {
      console.log(error, 'error--');
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (showUnsubscribeModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showUnsubscribeModal]);

  const handleUnsubscribe = () => {
    setShowUnsubscribeModal(true);
  };

  const closeModal = () => {
    setShowUnsubscribeModal(false);
  };

  const confirmUnsubscribe = async () => {
    try {
      setUnsubscribing(true);

      const payload = {
        msisdn:localStorage.getItem('mobile')
      };

      console.log(payload,'payload=====================')

      const response = await unsubscribe(payload);
  console.log(response ,"response---")
      if (response.data.status==1) {
        toast.success(response.data.msg);
        localStorage.clear();
        setShowUnsubscribeModal(false);
        navigate("/");
      } else {
        toast.error(response.data.msg || "Unable to unsubscribe.");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.msg || "Unsubscribe failed.");
    } finally {
      setUnsubscribing(false);
    }
  };

  const handleLogout = () => {
    dispatch(removeUser());
    navigate("/");
  }

  return (
    <main className={classes.main}>
      <div className={classes.bgGlowOne}></div>
      <div className={classes.bgGlowTwo}></div>
      <div className={classes.bgGrid}></div>

      <section className={classes.wrapper}>
        <motion.div
          className={classes.topBar}
          initial={{ opacity: 0, y: -18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <motion.button
            className={classes.backBtn}
            onClick={() => navigate(-1)}
            whileHover={{ x: -3, scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
          >
            <FaArrowLeft />
          </motion.button>

          <div className={classes.headerContent}>
            <div className={classes.headerTopLine}>
              <span className={classes.headerDot}></span>
              <span className={classes.headerMiniText}>{t("94")}</span>
            </div>

            <h1 className={classes.pageTitle}>{t("95")}</h1>

            <div className={classes.headerBottomRow}>
              <p className={classes.pageSubTitle}>
                {t("96")}
              </p>
            </div>
          </div>
        </motion.div>

        <motion.section
          className={classes.profileHero}
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <div className={classes.profileLeft}>
            <div className={classes.avatarWrap}>
              <div className={classes.avatar}>

                {userProfile?.image ? (
                  <img
                    src={userProfile?.image}
                    alt={userProfile?.name || "User"}
                    className={classes.avatarImage}
                  />
                ) : (
                  getInitials(userProfile?.name) || 'User'
                )}
              </div>
            </div>

            <div className={classes.profileInfo}>
              <div className={classes.nameRow}>
                <h2 className={classes.userName}>{userProfile?.name}</h2>
                <span className={classes.statusBadge} onClick={() => setModal(true)}>{t("97")}</span>
              </div>

              <div className={classes.userMeta}>
                <div className={classes.metaItem}>
                  <FaUser />
                  <span>{userProfile.msisdn}</span>
                </div>

                <div className={classes.metaItem}>
                  <FaBolt />
                  <span>{userProfile.pack_type} {t("98")}</span>
                </div>
              </div>
            </div>
          </div>

          <motion.div
            className={classes.timeHighlight}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.15, duration: 0.35 }}
          >
            <div className={classes.timeLabel}>{t("99")}</div>
            <div className={classes.timeValue}>
              <FaClock />
              <span>{formatTime(userProfile.total_time_spent_seconds)}</span>
            </div>
          </motion.div>
        </motion.section>

        <section className={classes.statsGrid}>
          <motion.div
            className={classes.statCard}
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.35 }}
            whileHover={{ y: -4 }}
          >
            <div className={classes.statIcon}>
              <FaClock />
            </div>
            <div className={classes.statContent}>
              <div className={classes.statLabel}>{t("100")}</div>
              <div className={classes.statValue}>{formatTime(userProfile.total_time_spent_seconds)}</div>
            </div>
          </motion.div>

          <motion.div
            className={classes.statCard}
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.29, duration: 0.35 }}
            whileHover={{ y: -4 }}
          >
            <div className={classes.statIcon}>
              <FaBolt />
            </div>
            <div className={classes.statContent}>
              <div className={classes.statLabel}>{t("101")}</div>
              <div className={classes.statValue}>{userProfile?.pack_type} {t("98")}</div>
            </div>
          </motion.div>
        </section>

        <motion.section
          className={classes.subscriptionCard}
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.35 }}
        >
          <div className={classes.subscriptionTop}>
            <div>
              <h3 className={classes.subscriptionTitle}>{t("103")}</h3>
              <p className={classes.subscriptionText}>
                {t("104")}
              </p>
            </div>

            <div className={classes.currentPlanPill}>{userProfile.pack_type} {t("98")}</div>
          </div>

          <div className={classes.subscriptionBottom}>
            <button
              className={classes.secondaryBtn}
              onClick={() => navigate("/home")}
            >
              {t("105")}
            </button>

            <motion.button
              className={classes.logoutBtn}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={handleLogout}
            >
              <FaArrowRightFromBracket />
              {t("106")}
            </motion.button>

            <motion.button
              className={classes.unsubscribeBtn}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={handleUnsubscribe}
            >
              <FaPowerOff />
              {t("107")}
            </motion.button>
          </div>
        </motion.section>
      </section>

      <AnimatePresence>
        {showUnsubscribeModal && (
          <motion.div
            className={classes.modalOverlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className={classes.modalBox}
              initial={{ opacity: 0, y: 30, scale: 0.94 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.96 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className={classes.modalCloseBtn} onClick={closeModal}>
                <FaXmark />
              </button>

              <div className={classes.modalIconWrap}>
                <FaTriangleExclamation />
              </div>

              <h3 className={classes.modalTitle}>{t("108")}</h3>

              <p className={classes.modalText}>
                {t("109")}
              </p>

              <div className={classes.modalActions}>
                <button
                  className={classes.modalCancelBtn}
                  onClick={closeModal}
                  disabled={unsubscribing}
                >
                  {t("110")}
                </button>

                <button
                  className={classes.modalConfirmBtn}
                  onClick={confirmUnsubscribe}
                  disabled={unsubscribing}
                >
                  {unsubscribing ? "..." : t("111")}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <EditProfileModal
        modal={modal}
        setModal={setModal}
        name={userProfile?.name}
        image={userProfile?.image}
        fetchUserProfile={fetchUserProfile}
      />
    </main>
  );
};

export default ProfilePage;